import { render, staticRenderFns } from "./ButtonAssetDefect.vue?vue&type=template&id=4f6255d2&scoped=true"
import script from "./ButtonAssetDefect.vue?vue&type=script&lang=js"
export * from "./ButtonAssetDefect.vue?vue&type=script&lang=js"
import style0 from "./ButtonAssetDefect.vue?vue&type=style&index=0&id=4f6255d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6255d2",
  null
  
)

export default component.exports